module.exports = __webpack_public_path__ + "static/media/featureImg4.eca7f5d8.png";